import React, { useState, useEffect } from "react";

import {
  Root,
  Container,
  LogoContainer,
  MenuBtn,
  DesktopNavList,
  NavLink,
} from "./Navigation.style";

import MobileMenu from "./MobileMenu";
import ModalEntry from "../ModalEntry/ModalEntry";
import ModalRules from "../ModalRules/ModalRules";
//import ModalGetNotified from "../ModalGetNotified/ModalGetNotified";

const Navigation = ({ activeSection }) => {
  const [menuIsShow, setMenuIsShow] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  // const [getNotifiedShow, setGetNotifiedShow] = useState(false);
  const [entryShow, setEntryShow] = useState(false);
  const [rulesShow, setRulesShow] = useState(false);

  const handleSticky = () => {
    window.scrollY >= 48 ? setIsSticky(true) : setIsSticky(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleSticky);
    return () => {
      window.removeEventListener("scroll", handleSticky);
    };
  }, []);

  return (
    <Root $isSticky={isSticky}>
      <Container>
        {!menuIsShow && (
          <>
            <LogoContainer href="https://olesmoky.com/" $isSticky={isSticky}>
              Ole Smoky - Big Green Egg
            </LogoContainer>

            <MenuBtn
              className={menuIsShow ? "--close" : "--menu"}
              onClick={() => setMenuIsShow(!menuIsShow)}
              $isSticky={isSticky}
            />
          </>
        )}

        {menuIsShow && (
          <MobileMenu
            activeSection={activeSection}
            onCloseMenu={() => setMenuIsShow(false)}
            onGetNotified={() => {
              setMenuIsShow(false);
              setEntryShow(true);
            }}
          />
        )}

        <DesktopNavList>
          <li>
            <NavLink
              href="/#home"
              className={activeSection === "home" && "--active"}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              href="/#prizes"
              className={activeSection === "prizes" && "--active"}
            >
              Prizes
            </NavLink>
          </li>
          <li>
            <NavLink
              href="/#cocktails"
              className={activeSection === "cocktails" && "--active"}
            >
              Cocktails
            </NavLink>
          </li>
          <li>
            <NavLink
              href="/#bbq"
              className={activeSection === "bbq" && "--active"}
            >
              BBQ
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              href="/#faq"
              className={activeSection === "faq" && "--active"}
            >
              Faq
            </NavLink>
          </li> */}

          {/* <li>
            <NavLink
              as="button"
              style={{ color: "#a18336" }}
              onClick={() => setEntryShow(true)}
            >
              Enter To Win
            </NavLink>
          </li> */}
        </DesktopNavList>
      </Container>

      {entryShow && (
        <ModalEntry
          onClose={() => setEntryShow(false)}
          onRulesShow={() => {
            setEntryShow(false);
            setRulesShow(true);
          }}
        />
      )}

      {rulesShow && (
        <ModalRules
          onClose={() => {
            setRulesShow(false);
            setEntryShow(true);
          }}
        />
      )}
    </Root>
  );
};

export default Navigation;
